import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onResetFilters }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-8 md:p-12 text-center">
      <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
      </div>
      <h3 className="font-heading font-semibold text-xl md:text-2xl text-foreground mb-2">
        Geen opdrachten gevonden
      </h3>
      <p className="text-sm md:text-base text-muted-foreground mb-6 max-w-md mx-auto">
        Er zijn geen opdrachten die voldoen aan je huidige filters. Probeer je zoekcriteria aan te passen.
      </p>
      <Button
        variant="outline"
        onClick={onResetFilters}
        iconName="RotateCcw"
        iconPosition="left"
      >
        Reset alle filters
      </Button>
    </div>
  );
};

export default EmptyState;